module.exports = __webpack_public_path__ + "static/img/sean-kong-491810-unsplash.86b08d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sean-kong-491810-unsplash.jpg
// module id = H4r0
// module chunks = 1